(function () {
  'use strict';

  var instances = new WeakMap();

  function SignatureLooks(root) {
    this.root = root;
    this.track = root.querySelector('.signature-looks__track');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.signature-looks__slide'));

    if (!this.track || this.slides.length === 0) return;

    this.prev = root.querySelector('[data-slider-prev]');
    this.next = root.querySelector('[data-slider-next]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.signature-looks__dot'));

    this.current = 0;
    this.timer = null;

    this.autoplay = root.dataset.autoplay === 'true';
    this.speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;

    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reducedMotion = motionQuery.matches;
    this._motionListener = function (e) {
      this.reducedMotion = e.matches;
      if (this.reducedMotion) this.stop();
      else this.maybeStart();
    }.bind(this);
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', this._motionListener);

    this._handlers = [];
    this.init();
  }

  SignatureLooks.prototype.init = function () {
    this.bind();
    this.go(0, true);
    if (this.slides.length > 1) this.maybeStart();
  };

  SignatureLooks.prototype._on = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts || false);
    this._handlers.push({ target: target, type: type, fn: fn, opts: opts || false });
  };

  SignatureLooks.prototype.bind = function () {
    var self = this;

    if (this.prev) this._on(this.prev, 'click', function () { self.go(self.current - 1); self.restart(); });
    if (this.next) this._on(this.next, 'click', function () { self.go(self.current + 1); self.restart(); });

    this.dots.forEach(function (dot, i) {
      self._on(dot, 'click', function () { self.go(i); self.restart(); });
    });

    if (this.slides.length > 1) {
      this._on(this.root, 'mouseenter', function () { self.stop(); });
      this._on(this.root, 'mouseleave', function () { self.maybeStart(); });
      this._on(this.root, 'focusin', function () { self.stop(); });
      this._on(this.root, 'focusout', function (e) {
        if (!self.root.contains(e.relatedTarget)) self.maybeStart();
      });

      this._on(this.root, 'keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.current - 1); self.restart(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.current + 1); self.restart(); }
      });

      var startX = null;
      this._on(this.track, 'touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this._on(this.track, 'touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          self.go(self.current + (dx < 0 ? 1 : -1));
          self.restart();
        }
        startX = null;
      }, { passive: true });

      this._visibilityHandler = function () {
        if (document.hidden) self.stop();
        else self.maybeStart();
      };
      document.addEventListener('visibilitychange', this._visibilityHandler);
    }
  };

  SignatureLooks.prototype.go = function (index, silent) {
    var n = this.slides.length;
    if (n === 0) return;
    var next = ((index % n) + n) % n;

    var prevSlide = this.slides[this.current];
    var nextSlide = this.slides[next];

    if (prevSlide && prevSlide !== nextSlide) {
      prevSlide.classList.remove('is-active');
      prevSlide.setAttribute('aria-hidden', 'true');
    }
    if (nextSlide) {
      nextSlide.classList.add('is-active');
      nextSlide.removeAttribute('aria-hidden');
    }

    if (this.dots.length) {
      var prevDot = this.dots[this.current];
      var nextDot = this.dots[next];
      if (prevDot && prevDot !== nextDot) {
        prevDot.classList.remove('is-active');
        prevDot.setAttribute('aria-selected', 'false');
      }
      if (nextDot) {
        nextDot.classList.add('is-active');
        nextDot.setAttribute('aria-selected', 'true');
      }
    }

    this.current = next;
  };

  SignatureLooks.prototype.start = function () {
    var self = this;
    this.timer = window.setInterval(function () { self.go(self.current + 1); }, this.speed);
  };

  SignatureLooks.prototype.stop = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  SignatureLooks.prototype.maybeStart = function () {
    if (!this.autoplay || this.reducedMotion || this.timer) return;
    if (this.slides.length < 2) return;
    if (document.hidden) return;
    this.start();
  };

  SignatureLooks.prototype.restart = function () {
    this.stop();
    this.maybeStart();
  };

  SignatureLooks.prototype.goToBlock = function (blockId) {
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].dataset.blockId === blockId) {
        this.stop();
        this.go(i);
        return;
      }
    }
  };

  SignatureLooks.prototype.destroy = function () {
    this.stop();
    this._handlers.forEach(function (h) {
      h.target.removeEventListener(h.type, h.fn, h.opts);
    });
    this._handlers.length = 0;
    if (this._visibilityHandler) {
      document.removeEventListener('visibilitychange', this._visibilityHandler);
    }
  };

  function init(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new SignatureLooks(root));
  }

  function destroy(root) {
    if (!root) return;
    var inst = instances.get(root);
    if (inst) {
      inst.destroy();
      instances.delete(root);
    }
  }

  function findRoot(target) {
    if (!target) return null;
    if (target.classList && target.classList.contains('signature-looks')) return target;
    if (typeof target.querySelector === 'function') return target.querySelector('.signature-looks');
    return null;
  }

  function initAll() {
    document.querySelectorAll('.signature-looks').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = findRoot(e.target);
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = findRoot(e.target);
    if (root) destroy(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = findRoot(e.target);
    if (!root) return;
    var inst = instances.get(root);
    if (inst && e.detail && e.detail.blockId) inst.goToBlock(e.detail.blockId);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = findRoot(e.target);
    if (!root) return;
    var inst = instances.get(root);
    if (inst) inst.maybeStart();
  });
})();
